/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultProductInfo interface.
 */
export function instanceOfFxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultProductInfo(value) {
    if (!('Name' in value) || value['Name'] === undefined)
        return false;
    if (!('Description' in value) || value['Description'] === undefined)
        return false;
    if (!('Price' in value) || value['Price'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultProductInfoFromJSON(json) {
    return FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultProductInfoFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultProductInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Name': json['Name'],
        'Description': json['Description'],
        'Price': json['Price'],
        'ImageUrl': json['ImageUrl'] == null ? undefined : json['ImageUrl'],
    };
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultProductInfoToJSON(json) {
    return FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultProductInfoToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultProductInfoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Name': value['Name'],
        'Description': value['Description'],
        'Price': value['Price'],
        'ImageUrl': value['ImageUrl'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultProductInfo.js.map